module.exports = __webpack_public_path__ + "static/media/sky.bcc9ed34.png";